module.exports = __webpack_public_path__ + "assets/img/功能介绍-传统模式.95e34174.png";